'use client';

type UserIconProps = {
  className?: string;
};

export const UserIcon = ({ className }: UserIconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3662 5.3125C11.9966 5.18716 12.6504 5.25112 13.2441 5.49707C13.8379 5.74305 14.3451 6.16 14.7021 6.69434C15.0593 7.2288 15.25 7.85721 15.25 8.5C15.25 9.36195 14.9073 10.1884 14.2979 10.7979C13.6884 11.4073 12.862 11.75 12 11.75C11.3572 11.75 10.7288 11.5593 10.1943 11.2021C9.66 10.8451 9.24305 10.3379 8.99707 9.74414C8.75112 9.15035 8.68716 8.49658 8.8125 7.86621C8.9379 7.23577 9.24763 6.65667 9.70215 6.20215C10.1567 5.74763 10.7358 5.4379 11.3662 5.3125ZM12 5.75C11.4562 5.75 10.9249 5.91175 10.4727 6.21387C10.0205 6.51601 9.66713 6.94485 9.45898 7.44727C9.25089 7.94964 9.19672 8.5028 9.30273 9.03613C9.40884 9.56958 9.67107 10.0597 10.0557 10.4443C10.4403 10.8289 10.9304 11.0912 11.4639 11.1973C11.9972 11.3033 12.5504 11.2491 13.0527 11.041C13.5552 10.8329 13.984 10.4795 14.2861 10.0273C14.5882 9.57514 14.75 9.04384 14.75 8.5C14.75 7.77066 14.4601 7.07139 13.9443 6.55566C13.4286 6.03994 12.7293 5.75 12 5.75Z"
        fill="currentcolor  "
        stroke="currentcolor"
      />
      <path
        d="M12 14.25C13.1729 14.25 15.0228 14.255 16.5752 14.8145C17.3433 15.0913 18.0066 15.4935 18.4775 16.0703C18.9413 16.6384 19.2487 17.4117 19.25 18.4932C19.2491 18.5609 19.2218 18.6259 19.1738 18.6738C19.1275 18.7202 19.0654 18.7465 19 18.749C18.9346 18.7465 18.8725 18.7202 18.8262 18.6738C18.7903 18.638 18.7662 18.5928 18.7559 18.5439L18.75 18.4932C18.7494 17.9658 18.6773 17.4433 18.458 16.9619C18.2342 16.4709 17.8705 16.0526 17.3359 15.7197C16.2957 15.0722 14.6101 14.75 12 14.75C9.38987 14.75 7.70431 15.0722 6.66406 15.7197C6.12949 16.0526 5.76581 16.4709 5.54199 16.9619C5.32172 17.4454 5.25 17.9703 5.25 18.5C5.25 18.5663 5.22364 18.6299 5.17676 18.6768C5.12987 18.7236 5.06631 18.75 5 18.75C4.93369 18.75 4.87013 18.7236 4.82324 18.6768C4.77636 18.6299 4.75 18.5663 4.75 18.5C4.75 17.4149 5.05773 16.6396 5.52246 16.0703C5.99337 15.4935 6.65666 15.0913 7.4248 14.8145C8.97723 14.255 10.8271 14.25 12 14.25Z"
        fill="currentcolor"
        stroke="currentcolor"
      />
    </svg>
  );
};
